export var POINT_CHANGE = 1;
export var APP_VERSION = 1050;
export var STORE_VERSION = 1050;
export var GAME_VERSION = "10.50";
export var COOKIE_CONSENT_KEY = "consent" // export const HEALTH_POINT_CHANGE = 3.5
 // export const HEALTH_CHANGE_NEGATIVE = -3
 // export const HEALTH_CHANGE_POSITIVE = 2
 // export const HEALTH_CHANGE_MIN = 0
 // export const HEALTH_CHANGE_MAX = 100
 // export const HEALTH_DEFAULT = 75
;
